export const paymentStatuses = Object.freeze({
  canceled: 0,
  faulted: 1,
  initialized: 10,
  waitingForPayment: 20,
  paid: 100,
});
